import { QuizQuestionField } from '@/pages/pii-training/QuizQuestionField';
import type { FormStepProps } from '@/pages/pii-training/piiTraining.types';
import { Stack, Text } from '@careflux/primitives';
import { useWatch } from 'react-hook-form';

export const QuizStep = ({ copy, control }: FormStepProps) => {
  const answers = useWatch({ control, name: ['example1', 'example2', 'example3'] });
  const allAnswered = answers.every((answer) => answer !== null);

  return (
    <Stack as="section" gap="xl">
      {copy.quiz.questions.map((question, index) => (
        <QuizQuestionField key={question.id} question={question} index={index} copy={copy.quiz} control={control} />
      ))}
      {!allAnswered && (
        <Text asChild size="sm" color="muted">
          <p>{copy.quiz.unansweredHint}</p>
        </Text>
      )}
    </Stack>
  );
};
